// extracted by mini-css-extract-plugin
module.exports = {"upload":"Attachments_upload__uaf_-","btn":"Attachments_btn__1ZkEK"};